// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertManagerListItemExpendablePanel-module__container__mrDHt","tabs-container":"AlertManagerListItemExpendablePanel-module__tabs-container__1ZW7g"};